import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-info-label',
  templateUrl: './info-label.component.html',
  styleUrls: ['./info-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoLabelComponent{
}
